import styled from '@emotion/styled';
import H5 from '@base/H5/H5';
import Link from '@base/Link/Link';
import { Fonts, Spacings } from '@styles/index';
import { DOW2_SEE_ALL_CLICKED } from '@constants/segment';
import { segment } from '@actions/analytics';
import useGoalEventProps from '@hooks/useGoalEventProps';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import useMyDoubts from '@api/hooks/goal/custom-doubts/useMyDoubts';
import DoubtCard from './DoubtCard';

const StyH4 = styled(H5)`
  color: var(--color-text-primary);
`;
const TopDiv = styled.div`
  grid-column: span 18;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${Spacings.SPACING_6B};
  margin-bottom: ${Spacings.SPACING_1B};
`;

const RecentDoubts = ({ goalUID }) => {
  const routeGoalSegmentData = useGoalEventProps({ goalUID });
  const { goalInfo } = useGoalInfo(goalUID);
  const { doubts: allDoubts } = useMyDoubts(goalUID);
  const myDoubts = allDoubts.slice(0, 3);
  const recentDoubts = myDoubts.map((doubt) => (
    <DoubtCard key={doubt.uid} data={doubt} goalUID={goalUID} />
  ));
  const href = '/goal/[goalSlug]/[goalUID]/doubts-and-solutions/my-doubts';
  const as = `/goal/${goalInfo.slug}/${goalInfo.uid}/doubts-and-solutions/my-doubts`;
  const anchorStyle = `
  color: var(--color-i-green);
  font-size: ${Fonts.SMALL};
  font-weight: ${Fonts.BOLD};
`;
  const handleOnClick = () => {
    segment.track(DOW2_SEE_ALL_CLICKED, {
      feature_version: 2,
      ...routeGoalSegmentData
    });
  };

  return (
    <>
      {recentDoubts.length > 0 && (
        <TopDiv>
          <StyH4>Recent doubts</StyH4>
          {allDoubts.length > 3 ? (
            <Link
              href={href}
              as={as}
              onClick={handleOnClick}
              anchorStyle={anchorStyle}
            >
              SEE ALL
            </Link>
          ) : null}
        </TopDiv>
      )}
      {recentDoubts}
    </>
  );
};

export default RecentDoubts;
